import React from "react";

interface Props {
  height: number;
  width: number;
  color: string;
}

export default function CreditCardIcon(props: Props): JSX.Element {
  const { width, height, color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "16"}
      viewBox="0 0 20 16"
    >
      <path
        id="Caminho_10291"
        data-name="Caminho 10291"
        d="M20,4H4A1.985,1.985,0,0,0,2.01,6L2,18a1.993,1.993,0,0,0,2,2H20a1.993,1.993,0,0,0,2-2V6A1.993,1.993,0,0,0,20,4Zm0,14H4V12H20ZM20,8H4V6H20Z"
        transform="translate(-2 -4)"
        fill={color || "#b9bec2"}
      />
    </svg>
  );
}
